import React, {useState, useRef, useEffect} from "react";
import "./sections.scss";

function VideoSec({item}){

    let ref = useRef(null)

    const playVideo = ()=>{
        ref.current.play()
    }


    return(
        <div className="video-content" style={{margin: "20px 16px 0 16px"}}>
            {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
            <video
                ref={ref}
                // onLoadedData={()=>playVideo()}
                width="100%" height="240" controls autoPlay muted>
                {/*<source src="https://www.w3schools.com/tags/movie.mp4" type="video/mp4" />*/}
                <source src={item.items[0].video} type="video/mp4" />
                        Your browser does not support the video tag.
            </video>
        </div>
    )
}

export default VideoSec
